import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'src/components/HTKit/Grid';
import styles from './styles.scss';

const ProductWorksWith = ({ data = [], className }) => (
  <section className={styles.container}>
    <Grid.Fluid classes={className}>
      <h4 className="marginBottom-medium text-align-center">Works with:</h4>
      <Grid.Row>
        <Grid.Column lg={8} lgOffset={2}>
          <Grid.Row>
            {data.map((brand) => {
              return (
                <Grid.Column sm={2} md={2} lg={3} key={brand.id} classes={styles.columnOverrides}>
                  <div className={styles.textContainer}>
                    <img className={styles.brandImage} src={brand.attachment.medium} />
                    <h6 className="paddingTop-small">{brand.entity}</h6>
                  </div>
                </Grid.Column>
              );
            })}
          </Grid.Row>
        </Grid.Column>
      </Grid.Row>
    </Grid.Fluid>
  </section>
);

ProductWorksWith.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      entity: PropTypes.string,
      attachment: PropTypes.shape({
        medium: PropTypes.string,
      }),
    }),
  ),
  className: PropTypes.string,
};

export default memo(ProductWorksWith);
